<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form inline size="small">
        <el-form-item label="关键词">
          <el-input
            v-model="listQuery.keyword"
            placeholder="来源接口/酒店ID/编码/公司ID/等级编码/会员等级"
            clearable
            style="width: 250px"
          />
        </el-form-item>
        <el-form-item label="丽呈酒店ID">
          <el-input
            v-model="listQuery.hotel_id"
            placeholder="精确查询"
            clearable
            style="width: 150px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="酒店编码">
          <el-input
            v-model="listQuery.hotel_code"
            placeholder="精确查询"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="价格方案ID">
          <el-input
            v-model="listQuery.price_plan_id"
            placeholder="精确查询"
            clearable
            style="width: 150px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <li-cheng-sync-button
            resource="product"
            label="同步指定酒店产品"
            @synced="getList"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      stripe
      size="small"
    >
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="API账号ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.api_account_id }}
        </template>
      </el-table-column>

      <el-table-column label="价格方案ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.price_plan_id }}
        </template>
      </el-table-column>

      <el-table-column label="数据来源接口" min-width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.source_api }}
        </template>
      </el-table-column>

      <el-table-column label="分组ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.group_id }}
        </template>
      </el-table-column>

      <el-table-column label="丽呈酒店ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_id }}
        </template>
      </el-table-column>

      <el-table-column label="酒店编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_code }}
        </template>
      </el-table-column>

      <el-table-column label="协议公司ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.company_id }}
        </template>
      </el-table-column>

      <el-table-column label="企业等级编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.corp_level_code }}
        </template>
      </el-table-column>

      <el-table-column label="入住日期" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.check_in_date }}
        </template>
      </el-table-column>

      <el-table-column label="离店日期" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.check_out_date }}
        </template>
      </el-table-column>

      <el-table-column label="会员等级" min-width="100" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.member_rank_code === '1000'">银会员</span>
          <span v-else-if="scope.row.member_rank_code === '1001'">金会员</span>
          <span v-else-if="scope.row.member_rank_code === '1002'">白金会员</span>
          <span v-else-if="scope.row.member_rank_code === '1003'">钻石会员</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="同步时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.sync_at }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

      <el-table-column label="其他" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.request_json || scope.row.body_json">...</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleViewDetail(scope.row)"
          >
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="产品价量详情"
      :visible.sync="dialogDetailVisible"
      width="700px"
      :close-on-click-modal="true"
    >
      <div class="detail-content">
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="丽呈酒店ID">
            {{ currentRow.hotel_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="酒店编码">
            {{ currentRow.hotel_code || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="协议公司ID">
            {{ currentRow.company_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="企业等级编码">
            {{ currentRow.corp_level_code || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="入住日期">
            {{ currentRow.check_in_date || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="离店日期">
            {{ currentRow.check_out_date || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="会员等级">
            <span v-if="currentRow.member_rank_code === '1000'">银会员</span>
            <span v-else-if="currentRow.member_rank_code === '1001'">金会员</span>
            <span v-else-if="currentRow.member_rank_code === '1002'">白金会员</span>
            <span v-else-if="currentRow.member_rank_code === '1003'">钻石会员</span>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="请求JSON">
            {{ currentRow.request_json || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="请求体JSON">
            {{ currentRow.body_json || '无' }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      // 搜索参数
      listQuery: {
        page: 1,
        limit: 10,
        keyword: undefined,
        hotel_id: undefined,
        hotel_code: undefined,
        price_plan_id: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      },
      // 日期范围
      dateRange: null,
      // 查看详情弹窗
      dialogDetailVisible: false,
      currentRow: {},
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    getList() {
      this.listLoading = true
      // 处理日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.start_at = this.dateRange[0]
        this.listQuery.end_at = this.dateRange[1]
      } else {
        this.listQuery.start_at = undefined
        this.listQuery.end_at = undefined
      }

      // 处理空值参数
      const params = {}
      Object.keys(this.listQuery).forEach((key) => {
        const val = this.listQuery[key]
        if (val !== '' && val !== undefined && val !== null) {
          params[key] = val
        }
      })

      request({
        url: '/api/backend/liCheng/hotel/productSourceList',
        method: 'get',
        params: params,
      })
        .then((response) => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 点击查询按钮
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 点击重置按钮
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        keyword: undefined,
        hotel_id: undefined,
        hotel_code: undefined,
        price_plan_id: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      }
      this.dateRange = null
      this.getList()
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 查看详情
    handleViewDetail(row) {
      this.currentRow = Object.assign({}, row)
      this.dialogDetailVisible = true
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 20px;
}
.detail-content {
  max-height: 500px;
  overflow: auto;
}
</style>
